import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { ProductAddToOrderTemplateComponent as OriginalComponent } from '../../shared/product-add-to-order-template/product-add-to-order-template.component';

@Component({
  selector: 'ish-lazy-product-add-to-order-template',
  templateUrl: './lazy-product-add-to-order-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyProductAddToOrderTemplateComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/order-templates/shared/product-add-to-order-template/product-add-to-order-template.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() displayType: OriginalComponent['displayType'];

  @Input() cssClass: OriginalComponent['cssClass'];

  @Input() ariaHidden: OriginalComponent['ariaHidden'];


  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('orderTemplates').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../order-templates.module`).then(m => m.OrderTemplatesModule);

    const { ProductAddToOrderTemplateComponent: originalComponent } = await import('../../shared/product-add-to-order-template/product-add-to-order-template.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.displayType = this.displayType;
      
        this.component.instance.cssClass = this.cssClass;
      
        this.component.instance.ariaHidden = this.ariaHidden;
      

      
    }
  }

}
